import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

import { authStore } from '@/store/auth.store';

const requireAuth = (to, from, next) => {
  if (!authStore.isAuthenticated && to.path !== '/login') {
    next('/login');
  } else {
    next();
  }
};

const routes = [
  {
    path: '/',
    redirect: 'home',
    component: DashboardLayout,
    beforeEnter: requireAuth,
    children: [
      // {
      //   path: '/dashboard',
      //   name: 'dashboard',
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      // },
      {
        path: '/',
        name: 'home',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Home.vue')
      },

      {
        path: '/loading',
        name: 'loading',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Loading.vue')
      },

      {
        path: '/risks',
        name: 'risks',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/RiskList.vue')
      },

      {
        path: '/risk/:id',
        name: 'risk',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/RiskDetail.vue')
      },
      // {
      //  path: '/icons',
      //  name: 'icons',
      //  component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      // },
      // {
      //  path: '/profile',
      //  name: 'profile',
      //  component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue')
      // },
      // {
      //  path: '/maps',
      //  name: 'maps',
      //  component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue')
      // },
      //  {
      //   path: '/tables',
      //   name: 'tables',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue')
      // }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Auth/SignIn.vue')
      },
      // {
      //   path: '/register',
      //   name: 'register',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      // },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
